// PARTNER-FAHRERLISTE-KOMPAKT-001 — Profilfoto-Adresse im Partnerportal.
//
// users.avatar speichert einen Serverpfad (`/public-avatars/<id>.webp`, Altbestand `/uploads/…`).
// Ausgeliefert wird er NUR vom API-Host (backend/src/server.js: app.use('/public-avatars', …)).
// Relativ im Portal gelesen zeigt er auf partner.voogo.de — Caddy antwortet dort mit der
// SPA-index.html (gemessen 15.09.2026: HTTP 200 text/html), das Bild bricht still.
// Deshalb: Serverpfad + geparster API-Origin (dieselbe Quelle wie der Socket, nie String-Ersetzung).
import { socketOrigin } from '../services/socketOrigin';

export function avatarSrc(avatar, apiUrl = process.env.REACT_APP_API_URL) {
  if (typeof avatar !== 'string') return null;
  const value = avatar.trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith('/') && !value.startsWith('//')) return `${socketOrigin(apiUrl)}${value}`;
  return null;
}

export default avatarSrc;
